import { Error, ErrorTargets } from '../../../models/response';

export enum NetworkErrorCodes {
  ConnectionIssues = 'ConnectionIssues',
}

export declare namespace NetworkError {
  type ErrorTypes = ConnectionIssues;

  type ErrorWrapper = {
    error: ErrorTypes;
  };

  /* Unexpected connection error encountered by the HTTP client */
  type ConnectionIssues = Error<0, NetworkErrorCodes.ConnectionIssues, ErrorTargets.Network>;
}
